import { func_validation } from 'functions';
import { useEffect, useRef, useState } from 'react';

export function useDropdownList(props) {
    const {
        allDebitNoteList,
        getAllDebitNoteList_requesting,
        isAccountRecordUpdatedSuccessfully,
    } = props;

    const [comIdList, setComIdList] = useState([]);
    const [accountCodeList, setAccountCodeList] = useState([]);
    const [productCodeList, setProductCodeList] = useState([]);
    const [documentNumberList, setDocumentNumberList] = useState([]);

    const [selectedComId, setSelectedComId] = useState("");
    const [selectedAccountCode, setSelectedAccountCode] = useState("");
    const [selectedProductCode, setSelectedProductCode] = useState("");
    const [selectedDocumentNumber, setSelectedDocumentNumber] = useState("");
    const [selectedChargeMonth_start, setSelectedChargeMonth_start] = useState("");
    const [selectedChargeMonth_end, setSelectedChargeMonth_end] = useState("");

    let filters = useRef({});
    const [isRenderRequired, setIsRenderRequired] = useState();

    // Get Data
    function getAllDebitNoteList() {
        if (func_validation.isFunction(props.getAllDebitNote) &&
            (func_validation.isNullUndefined(isAccountRecordUpdatedSuccessfully) ||
                func_validation.isBooleanTrueNotNullUndefined(isAccountRecordUpdatedSuccessfully))) {

            props.getAllDebitNote(null, null, null, filters.current);
        }
    }
    useEffect(() => {
        getAllDebitNoteList();
    }, [
        JSON.stringify(filters), isAccountRecordUpdatedSuccessfully,
        selectedComId, selectedAccountCode, selectedProductCode, selectedDocumentNumber,
        selectedChargeMonth_start, selectedChargeMonth_end
    ]);

    function setDropdownLists() {
        if (func_validation.isArray(allDebitNoteList) &&
            func_validation.isBooleanFalseNotNullUndefined(getAllDebitNoteList_requesting)) {

            let comIdList_new = [];
            let accountCodeList_new = [];
            let productCodeList_new = [];
            let documentNumberList_new = [];

            // Used to check duplicates in O(1) time
            let referenceObj_comId = {}; 
            let referenceObj_accountCode = {}; 
            let referenceObj_productCode = {}; 
            let referenceObj_documentNumber = {};

            // Get lists
            for (let i = 0; i < allDebitNoteList.length; i++) {
                let companyId = func_validation.getObjectPropertyValueNotNullUndefined(allDebitNoteList[i], "CompanyId", "");
                let accountCode = func_validation.getObjectPropertyValueNotNullUndefined(allDebitNoteList[i], "AccountCode", "");
                let productCode = func_validation.getObjectPropertyValueNotNullUndefined(allDebitNoteList[i], "ProductCode", "");
                let documentNumber = func_validation.getObjectPropertyValueNotNullUndefined(allDebitNoteList[i], "ReferenceDocumentNo", "");

                let isCompanyIdFound = func_validation.getObjectPropertyValue(referenceObj_comId, companyId + "");
                let isAccountCodeFound = func_validation.getObjectPropertyValue(referenceObj_accountCode, accountCode + "");
                let isProductCodeFound = func_validation.getObjectPropertyValue(referenceObj_productCode, productCode + "");
                let isDocumentNumberFound = func_validation.getObjectPropertyValue(referenceObj_documentNumber, documentNumber + "");

                // Add to list
                if (!isCompanyIdFound &&
                    func_validation.isNumberValid(companyId)) {
                    referenceObj_comId[companyId] = true;
                    comIdList_new.push(companyId);
                }
                if (!isAccountCodeFound &&
                    func_validation.isStringTrimNotEmpty(accountCode)) {
                    referenceObj_accountCode[accountCode] = true;
                    accountCodeList_new.push(accountCode);
                }
                if (!isProductCodeFound &&
                    func_validation.isStringTrimNotEmpty(productCode)) {
                    referenceObj_productCode[productCode] = true;
                    productCodeList_new.push(productCode);
                }
                if (!isDocumentNumberFound &&
                    func_validation.isStringTrimNotEmpty(documentNumber)) {
                    referenceObj_documentNumber[documentNumber] = true;
                    documentNumberList_new.push(documentNumber);
                }
            }


            // Update List States

            let comIdListSorted_new = comIdList_new.sort();
            let comIdList_dropdown = func_validation.convertArrayToDropdownArrayFormat(comIdListSorted_new);
            setComIdList(comIdList_dropdown);

            let accountCodeListSorted_new = accountCodeList_new.sort();
            let accountCodeList_dropdown = func_validation.convertArrayToDropdownArrayFormat(accountCodeListSorted_new);
            setAccountCodeList(accountCodeList_dropdown);

            let productCodeListSorted_new = productCodeList_new.sort();
            let productCodeList_dropdown = func_validation.convertArrayToDropdownArrayFormat(productCodeListSorted_new);
            setProductCodeList(productCodeList_dropdown);

            let documentNumberListSorted_new = documentNumberList_new.sort();
            let documentNumberList_dropdown = func_validation.convertArrayToDropdownArrayFormat(documentNumberListSorted_new);
            setDocumentNumberList(documentNumberList_dropdown);
        }
    }
    useEffect(() => {
        setDropdownLists();
    }, [JSON.stringify(allDebitNoteList)]);

    return {
        comIdList,
        accountCodeList,
        productCodeList,
        documentNumberList,

        setSelectedComId,
        setSelectedAccountCode,
        setSelectedProductCode,
        setSelectedDocumentNumber,
        setSelectedChargeMonth_start,
        setSelectedChargeMonth_end,

        filters, setIsRenderRequired, isRenderRequired
    }
}